import type { ReactNode } from 'react';

export interface MetricCardProps {
    label: string;
    value: ReactNode;
    helper?: string;
    compact?: boolean;
    variant?: 'default' | 'plain';
    className?: string;
    labelClassName?: string;
    valueClassName?: string;
    minHeight?: number;
    minWidth?: number;
    rounded?: 'md' | 'xl';
}

export default function MetricCard({
    label,
    value,
    helper,
    compact,
    variant = 'default',
    className = '',
    labelClassName = '',
    valueClassName = '',
    minHeight = 72,
    minWidth = 0,
    rounded = 'xl',
}: MetricCardProps) {
    const containerBase =
        'flex flex-col items-center justify-center text-center gap-1' +
        (variant === 'default' ? ' rounded-md border border-gray-200 bg-white' : ' rounded-xl bg-white'); // plain: no border (design spec)
    const padding = compact ? ' px-1 py-3' : ' px-2 py-4';
    const heightStyle = ` min-h-[${minHeight}px]`;
    const widthStyle = minWidth > 0 ? ` min-w-[${minWidth}px]` : '';
    const roundedOverride = rounded === 'xl' ? containerBase.replace('rounded-md', 'rounded-xl') : containerBase;

    return (
        <div className={`${roundedOverride}${padding}${heightStyle}${widthStyle} ${className} flex-1`}>
            <span className={`text-xs font-medium tracking-wide text-gray-600 ${labelClassName}`}>{label}</span>
            <div className={`text-xl font-semibold text-gray-900 ${valueClassName}`}>{value}</div>
            {helper && <div className="text-xs text-gray-500">{helper}</div>}
        </div>
    );
}
